// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Device Health states
 * 
 * NORMAL:
 *   The Device functions normally.
 * FAILURE:
 *   Malfunction of the Device or any of its peripherals.
 *   Typically caused device-internal or is process related.
 * CHECK_FUNCTION:
 *   Functional checks are currently performed. Examples:
 *   Change of configuration, local operation, and substitute value entered.
 * OFF_SPEC:
 *   "Off-spec" means that the Device is operating outside its specified range
 *   (e.g. measuring or temperature range) or that internal diagnoses indicate deviations
 *   from measured or set values due to internal problems in the Device or process characteristics.
 * MAINTENANCE_REQUIRED:
 *   Although the output signal is valid, the wear reserve is nearly exhausted or a function will soon be restricted
 *   due to operational conditions e.g. build-up of deposits.
 * @export
 */
export const UADIDeviceHealthEnumeration = {
    Normal: 'NORMAL',
    Failure: 'FAILURE',
    CheckFunction: 'CHECK_FUNCTION',
    OffSpec: 'OFF_SPEC',
    MaintenanceRequired: 'MAINTENANCE_REQUIRED'
} as const;
export type UADIDeviceHealthEnumeration = typeof UADIDeviceHealthEnumeration[keyof typeof UADIDeviceHealthEnumeration];


export function instanceOfUADIDeviceHealthEnumeration(value: any): boolean {
    for (const key in UADIDeviceHealthEnumeration) {
        if (Object.prototype.hasOwnProperty.call(UADIDeviceHealthEnumeration, key)) {
            if (UADIDeviceHealthEnumeration[key as keyof typeof UADIDeviceHealthEnumeration] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UADIDeviceHealthEnumerationFromJSON(json: any): UADIDeviceHealthEnumeration {
    return UADIDeviceHealthEnumerationFromJSONTyped(json, false);
}

export function UADIDeviceHealthEnumerationFromJSONTyped(json: any, ignoreDiscriminator: boolean): UADIDeviceHealthEnumeration {
    return json as UADIDeviceHealthEnumeration;
}

export function UADIDeviceHealthEnumerationToJSON(value?: UADIDeviceHealthEnumeration | null): any {
    return value as any;
}

export function UADIDeviceHealthEnumerationToJSONTyped(value: any, ignoreDiscriminator: boolean): UADIDeviceHealthEnumeration {
    return value as UADIDeviceHealthEnumeration;
}

